import { makeStyles } from '@material-ui/core/styles'

import { COLORS, FONT_FAMILY, FONT_WEIGHT } from 'styles'

const useStyles = makeStyles({
  pageCard: {
    backgroundColor: COLORS.WHITE,
    overflow: 'hidden',
  },
  pageTitle: {
    padding: '16px 24px 8px',
    fontFamily: FONT_FAMILY,
    fontWeight: FONT_WEIGHT.semiBold,
    fontSize: 20,
    color: COLORS.PRIMARY,
  },
  pageBody: {
    padding: '8px 24px 16px',
  },
  pageActions: {
    display: 'flex',
    justifyContent: 'flex-end',
    padding: '12px 24px 16px',
  },
  fieldLabel: {
    margin: '16px 0 8px',
    fontSize: 16,
    fontFamily: FONT_FAMILY,
    fontWeight: FONT_WEIGHT.semiBold,
    color: COLORS.FONT,
  },
})

export { useStyles }
